// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-cda6a598] {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  color: #000000;\n}\n.item-holder[data-v-cda6a598] {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
